import { render, staticRenderFns } from "./MenuSpecial.vue?vue&type=template&id=7c51edcc&scoped=true&"
import script from "./MenuSpecial.vue?vue&type=script&lang=js&"
export * from "./MenuSpecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c51edcc",
  null
  
)

export default component.exports